module.exports = __webpack_public_path__ + "static/media/cdp.a12141db.svg";